/**
 * @fileoverview A paused plan's days as the gardener reads them, shared by the subscribe
 * page and the pause offer.
 *
 * Where: the subscribe page and the pause offer.
 * API: none.
 * Words: none of its own; the day is Luxon's, in the app's language.
 *
 * @module pauseDay
 */

import { DateTime } from 'luxon';

/**
 * A moment as the gardener's own day, "February 17" ("17 de febrero").
 *
 * @param iso - An ISO moment.
 * @param language - The app's language.
 * @returns The day, or '' when it does not read.
 */
export function pauseDay(iso: string | null | undefined, language: string): string {
  if (!iso) return '';
  const at = DateTime.fromISO(iso);
  return at.isValid ? at.setLocale(language).toLocaleString({ month: 'long', day: 'numeric' }) : '';
}
